import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/admins";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import history from "../../routes/History";

function* getAdminsListSaga({ payload }) {
  try {
    const response = yield call(apis.getAdminsList, payload);
    yield put(
      actions.getAdminsResponse({
        list: response.data.admins,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getAdminsRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* addAdminSaga({ payload }) {
  try {
    yield call(apis.addAdmin, payload);
    yield showSuccessMsg("addedSuccessfully");
    yield history.push(ROUTE_PATHS.admins);
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* editAdminSaga({ payload }) {
  try {
    yield call(apis.editAdmin, payload);
    yield showSuccessMsg("editedSuccessfully");
    yield history.push(ROUTE_PATHS.admins);
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getAdminSaga({ payload }) {
  try {
    const response = yield call(apis.getAdminDetails, payload);
    yield put(
      actions.getAdminDetailsResponse({
        adminDetails: response.data.admin,
      })
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* deleteAdminSaga({ payload }) {
  try {
    yield call(apis.deleteAdmin, payload);
    yield showSuccessMsg("deletedSuccessfully");
    yield put(
      actions.getAdminsRequest({
        items: 10,
        page: payload.currentPage,
      })
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

export default function* AdminsSagas() {
  yield takeEvery(types.GET_ADMINS_REQUEST, getAdminsListSaga);
  yield takeEvery(types.ADD_ADMIN_REQUEST, addAdminSaga);
  yield takeEvery(types.GET_ADMIN_DETAILS_REQUEST, getAdminSaga);
  yield takeEvery(types.EDIT_ADMIN_REQUEST, editAdminSaga);
  yield takeEvery(types.DELETE_ADMIN_REQUEST, deleteAdminSaga);
}
